module.exports = __webpack_public_path__ + "static/media/manage.ac190fe1.svg";